import { useEffect, useState } from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import SelectSearchable from "../SelectSeachble/SelectSearchble";
import { useCallback } from "react";
import { GetTokenDecoded } from "../../utils/storeUsuario";
import { ListarMetoPago } from "../../Service/Service.util";
import CardInfoDatos from "./CardInfoCliente";
import { ControllerSchearCliente } from "../../Service/Service.cliente";
import { useDispatch, useSelector } from "react-redux";
import { agregarFormaPago } from "../../redux/actions";
import { useTotalFactura } from "../../hook/useTotalFactura";
import { Input } from 'antd';
import { DeleteOutlined, CopyOutlined } from '@ant-design/icons';

import ListaFormaPagos from "./ListaFormaPagos";

function DatosFactura({ data }) {
    const { onClienteSeleccionado,
        datosBanco,
        handleClienteNew,
        reloadClientes,
        onInfoAdicional,
        handleDatosCheque,
        handleDatosTarjeta,
        handleDatosTransferencia,
        seccionVerificacion
    } = data

    const dispatch = useDispatch();

    const [metodoPago, setMetodoPago] = useState([]);
    const [selectedPagoOption, setSelectedPagoOption] = useState(null);
    const [montoPago, setMontoPago] = useState("");
    const [infoAdicional, setInfoAdicional] = useState("");
    // Colapsable propio, ya sin acordeon: arranca cerrada porque es la unica
    // seccion de verdad opcional.
    const [infoAbierta, setInfoAbierta] = useState(false);

    const { TextArea } = Input;

    const handleMontoChange = (event) => {
        const value = event.target.value.replace(/[^0-9.]/g, "");
        setMontoPago(value);
    };

    const handleInfoAdicionalChange = (event) => {
        setInfoAdicional(event.target.value);
        onInfoAdicional(event.target.value);
    };

    const { total } = useTotalFactura();

    const isPagoValido = selectedPagoOption && parseFloat(montoPago) > 0;


    const handlePagoChange = selectedOption => {
        setSelectedPagoOption(selectedOption);
    };

    const formasPago = useSelector((state) => state.formapagoredux.pagos) || [];
    const sumaPagosRegistrados = formasPago.reduce((acc, pago) => acc + pago.montoPago, 0);
    const nuevoMonto = parseFloat(montoPago) || 0;
    const totalPagado = sumaPagosRegistrados + nuevoMonto;
    const isPagoPermitido = totalPagado <= total;

    const handleAgregarPagos = () => {
        if (!selectedPagoOption || !montoPago || parseFloat(montoPago) <= 0) return;

        const datos = { ...selectedPagoOption, montoPago: parseFloat(montoPago) };
        const existePago = formasPago.some(pago => pago.value === datos.value);

        if (existePago) {
            alert("Forma de pago ya registrado.")
            return;
        }

        const tipoPago = metodoPago.find(pago => pago.value === datos.value);

        const acciones = {
            "CQ": () => handleDatosCheque(),
            "TC": () => handleDatosTarjeta(),
            "TRA": () => handleDatosTransferencia(),
        };

        if (acciones[tipoPago.codigo]) {
            acciones[tipoPago.codigo]();
        } else {
            dispatch(agregarFormaPago({ ...datos, datosBancario: { tipo: "EF" } }));
            handleDeleteTotal();
        }
    };

    const handleCopyTotal = () => {
        setMontoPago(total);
    }

    const handleDeleteTotal = () => {
        setMontoPago("");
    }

    const fetchInitialData = useCallback(async () => {

        const rMetodoPago = await ListarMetoPago();
        if (rMetodoPago && rMetodoPago.success) {
            const mpagos = rMetodoPago.data.map((pag) => ({ value: pag.idmetodo_pago, label: pag.metodo, ...pag }));
            setMetodoPago(mpagos);
        }

    }, []);


    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    useEffect(() => {
        if (datosBanco) {

            const pagoExistente = formasPago.find(pago => pago.datosBancario.tipo === datosBanco.tipo);

            if (pagoExistente) {
                const datosActualizados = {
                    ...pagoExistente,
                    datosBancario: datosBanco
                };

                dispatch(agregarFormaPago(datosActualizados));
            } else {
                const datosNuevoPago = {
                    ...selectedPagoOption,
                    montoPago: parseFloat(montoPago),
                    datosBancario: datosBanco
                };
                dispatch(agregarFormaPago(datosNuevoPago));
            }
            setMontoPago("");
            setSelectedPagoOption(null)
        }
    }, [datosBanco]);

    /* FACTURA-UI FASE 4: cambia SOLO el JSX. Ni un `useState`, ni un
       manejador, ni una llamada a servicio se mueven de sitio -- por eso
       `ListarMetoPago` y `ControllerSchearCliente` se siguen pidiendo
       exactamente una vez, igual que antes.

       Se devuelven DOS columnas hermanas: la pantalla las coloca como celdas
       del pie de tres columnas. */
    return (
        <>
            {/* -- Forma de pago: SIEMPRE abierta ------------------------- */}
            {/* Estaba colapsada dentro de un acordeón. No se etiqueta como
                "Obligatorio" porque HOY NO LO ES: se puede emitir sin
                registrar ningún pago, y poner esa etiqueta prometería una
                validación que el sistema no hace. */}
            <div className="fcrear__card fcrear__card--pie">
                <div className="fcrear__ch">
                    <span className="fcrear__ct">Forma de pago</span>
                </div>

                <div className="fcrear__pago">
                    <div className="fcrear__campo">
                        <span className="fcrear__lab">Método</span>
                        <SelectSearchable
                            listCompany={metodoPago}
                            handleChange={handlePagoChange}
                            placeholder="Seleccione..."
                            selectedOption={selectedPagoOption}
                        />
                    </div>

                    <div className="fcrear__campo">
                        <span className="fcrear__lab">Monto</span>
                        <div className="fcrear__monto">
                            <input
                                placeholder="$0.00"
                                type="text"
                                id="montoPago"
                                name="montoPago"
                                className="fcrear__monto-input"
                                value={montoPago}
                                onChange={handleMontoChange}
                            />
                            <button
                                type="button"
                                className="fcrear__monto-accion"
                                onClick={handleCopyTotal}
                                title="Usar el total de la factura"
                            >Total</button>
                            <button
                                type="button"
                                className="fcrear__monto-accion"
                                onClick={handleDeleteTotal}
                                title="Borrar el monto"
                            >Borrar</button>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="fcrear__btn fcrear__btn--destacado fcrear__btn--ancho"
                        disabled={!isPagoValido || !isPagoPermitido || total <= 0}
                        onClick={handleAgregarPagos}
                    >
                        Agregar pago
                    </button>

                    {/* "Pagos registrados" se absorbe aquí: es información de
                        pago y no merecía una caja propia en el centro de la
                        pantalla. Es el MISMO componente de siempre. */}
                    <ListaFormaPagos
                        data={{
                            handleDatosCheque: handleDatosCheque,
                            handleDatosTarjeta: handleDatosTarjeta,
                            handleDatosTransferencia: handleDatosTransferencia
                        }}
                    />

                    {/* El saldo sale de números que ya existían: el total de la
                        factura menos lo registrado. No se calcula nada nuevo. */}
                    <p className="fcrear__saldo">
                        {sumaPagosRegistrados >= total && total > 0
                            ? "Pago completo. No quedará saldo por cobrar."
                            : `Quedan $${Math.max(total - sumaPagosRegistrados, 0).toFixed(2)} por registrar.`}
                    </p>
                </div>
            </div>

            {/* -- Información adicional: lo único de verdad opcional ------ */}
            <div className="fcrear__col-media">
                {seccionVerificacion}

                <div className="fcrear__card fcrear__card--pie">
                    <button
                        type="button"
                        className="fcrear__ch fcrear__ch--boton"
                        onClick={() => setInfoAbierta((v) => !v)}
                        aria-expanded={infoAbierta}
                    >
                        <span className="fcrear__ct">Información adicional</span>
                        <span className="fcrear__opcional">Opcional</span>
                    </button>
                    {infoAbierta && (
                        <div className="fcrear__info">
                            <TextArea
                                rows={3}
                                placeholder="Digite información adicional..."
                                value={infoAdicional}
                                onChange={handleInfoAdicionalChange}
                                maxLength={300}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default DatosFactura;